import i18n from "i18next";
import { resources } from "../../locales/index.js";
function initTranslations() {
  if (i18n && i18n.isInitialized) {
    Object.keys(resources).forEach((lng) => {
      const language = (
        /** @type {SupportedLanguages} */
        lng
      );
      i18n.addResourceBundle(language, "omega", resources[language].omega, true, true);
    });
  }
}
export {
  initTranslations
};
//# sourceMappingURL=translations.js.map
